import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Field } from 'redux-form';
import SelectField from '../../../../../shared-components/SelectField/SelectField';
import ToggleSlider from './ToggleSlider/ToggleSlider';

const LOCALE_PREFIX = 'GB/pages/CAPage/CompletePopup';

const getFIList = (wallet) => {
    return wallet.map(fi => ({
        id: fi.optionId,
        displayText: fi.optionValue
    }));
};

export const validateDirectDebit = (values, props) => {
    const errors = {};
    const { directDebitBankAccount, directDebit } = values;
    if (directDebit) {
        if (!directDebitBankAccount || directDebitBankAccount === '') {
            _.set(errors, 'directDebitBankAccount', {});
        }
    }
    return errors;
};

export class ToggleFinancialInstruments extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        wallet: PropTypes.array.isRequired,
        handleToggleFI: PropTypes.func.isRequired,
        toggleFIOn: PropTypes.bool,
        showDirectDebitError: PropTypes.bool
    };

    render() {
        const {
            intl, wallet, showDirectDebitError, handleToggleFI, toggleFIOn
        } = this.props;

        let content;


        if (showDirectDebitError) {
            content = (
                <div id="ToggleFinancialInstruments">
                    <div className="direct-debit-wrapper direct-debit-error" id="direct-debit-error">
                        <div className="direct-debit-toggle clearfix">
                            <h3 className="delta">
                                <FormattedMessage id={`${LOCALE_PREFIX}.directDebitLabel`} />
                            </h3>
                        </div>
                        <span className="icon" />
                        <p className="error-message">
                            <FormattedMessage id={`${LOCALE_PREFIX}.directDebitError`} />
                        </p>
                    </div>
                </div>
            );
        } else {
            const fiList = getFIList(wallet);
            content = (
                <div id="ToggleFinancialInstruments">
                    <div className="direct-debit-wrapper direct-debit-setUp" id="direct-debit-setUp">
                        <Field
                            id="directDebit"
                            name="directDebit"
                            component={ToggleSlider}
                            checked={toggleFIOn}
                            toggle={handleToggleFI}
                        />
                        <p>
                            <FormattedMessage id={`${LOCALE_PREFIX}.directDebitMessage`} />
                        </p>
                        <Field
                            id="directDebitBankAccount"
                            name="directDebitBankAccount"
                            component={SelectField}
                            label={intl.formatMessage({id: `${LOCALE_PREFIX}.directDebitDropdown-label`})}
                            placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.directDebitDropdown`})}
                            optionList={fiList}
                            disabled={!toggleFIOn}
                        />
                    </div>
                </div>
            );
        }

        return (
            content
        );
    }
}

export const mapStateToProps = state => ({
    wallet: _.get(state, 'serverData.wallet', [])
});


export default connect(mapStateToProps)(injectIntl(ToggleFinancialInstruments));
